import { ComponentPropsWithoutRef, FC } from 'react';
import { Heading } from '@sravni/react-design-system/lib/Typography';

export const Headline: FC<ComponentPropsWithoutRef<'span'>> = (props) => {
    const { children, ...other } = props;
    const headline = typeof children === 'string' ? children : 'Заявка на кредит';

    return (
        <Heading level={3} {...other}>
            {headline}
        </Heading>
    );
};
